export const linear = (x: number) => x;

export const ease = (x: number) => (2 - x) * x;

export const timingFunctions = {
    linear,
    ease,
} as const;
